module.exports = __webpack_public_path__ + "media/images/icons/outlined/bars-62b8cdb15782a106469d7e0c801033a7.svg";